import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/UserIdIndicator.css';

interface UserIdIndicatorProps {
  isVisible: boolean;
}

const UserIdIndicator = ({ isVisible }: UserIdIndicatorProps) => {
  const auth = useAuth();
  const [userId, setUserId] = useState<number | null>(null);

  useEffect(() => {
    // Mettre à jour l'ID utilisateur dès que userData change
    if (auth?.userData && auth.userData.userId) {
      setUserId(auth.userData.userId);
      
      // Toujours afficher l'ID dans la console à chaque rendu
      console.log(`%c📌 Page chargée avec Utilisateur ID: ${auth.userData.userId}`, 
        'background-color: #4CAF50; color: white; padding: 2px 5px; border-radius: 3px;');
    } else {
      // Essayer de récupérer depuis sessionStorage comme fallback
      const storedUserId = sessionStorage.getItem('currentUserID');
      if (storedUserId) {
        setUserId(parseInt(storedUserId, 10));
        console.log(`%c📌 Page chargée avec Utilisateur ID (session): ${storedUserId}`, 
          'background-color: #FFC107; color: black; padding: 2px 5px; border-radius: 3px;');
      } else {
        setUserId(null);
        console.log('Aucun utilisateur authentifié détecté');
      }
    }
  }, [auth?.userData]);

  return userId && isVisible ? (
    <div className="user-id-indicator visible">
      <div className="user-id-content">
        <span className="user-id-label">USER ID:</span>
        <span className="user-id-value">{userId}</span>
      </div>
    </div>
  ) : null;
};

export default UserIdIndicator;
